import { render, staticRenderFns } from "./AddRecord.vue?vue&type=template&id=38a33933&scoped=true"
import script from "./AddRecord.vue?vue&type=script&lang=js"
export * from "./AddRecord.vue?vue&type=script&lang=js"
import style0 from "./AddRecord.vue?vue&type=style&index=0&id=38a33933&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38a33933",
  null
  
)

export default component.exports